module.exports = __webpack_public_path__ + "img/mode1.6f1773ca.png";